// import dayjs from "dayjs";
// import React, { useEffect } from "react";
// import { FaNotesMedical } from "react-icons/fa";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchRpmAgeWiseChronics } from "../../../../Redux/actions/rpmActions";

// function ChronicConditions() {
//   const { rpmAgeWiseChronicList } = useSelector((state) => state.rpm);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const payload = {
//       fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
//       toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
//       status: 1,
//     };
//     dispatch(fetchRpmAgeWiseChronics(payload));
//   }, [dispatch]);

//   return (
//     <div className="bg-white p-4 rounded-lg border shadow-sm xl:w-1/2 lg:w-1/2 w-full">
//       <h2 className="font-semibold font-inter text-gray-800 text-base mb-2">
//         Chronic Conditions{" "}
//         <span className="text-xs text-gray-500">(Age Group Distribution)</span>
//       </h2>
//       <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-3 gap-2 text-center text-sm mb-4">
//         {[
//           { label: "20–40 yrs", value: "14%" },
//           { label: "41–60 yrs", value: "15%" },
//           { label: "61–80 yrs", value: "18%" },
//           { label: "81–100 yrs", value: "25%" },
//           { label: "Others", value: "28%" },
//         ].map((item, i) => (
//           <div
//             key={i}
//             className="bg-white shadow-xl border rounded-md p-2 text-xs flex flex-col gap-2 items-center justify-center mt-1"
//           >
//             <span className="text-gray-500">{item.label}</span>
//             <span className="text-gray-800 font-semibold text-base font-inter">{item.value}</span>
//           </div>
//         ))}
//       </div>
//       <h3 className="text-sm font-inter font-medium text-gray-900 mt-5">
//         Chronic Condition Breakdown
//       </h3>
//       <ul className="space-y-2 text-sm mt-5">
//         {[
//           { label: "Cancer and Malignancy", count: "08" },
//           { label: "Cardiovascular (CAD)", count: "06" },
//           { label: "Cardiovascular", count: "03" },
//           { label: "Endocrine Disorders", count: "02" },
//         ].map((item, i) => (
//             <div>
//           <li key={i} className="flex items-center justify-between">
//             <span className="text-[#004B73] hover:underline cursor-pointer font-inter text-sm font-medium">
//               {item.label}
//             </span>
//             <span className="flex items-center gap-1 text-gray-800 font-medium">
//               <FaNotesMedical className="text-gray-500 font-semibold font-inter" /> {item.count}
//             </span>
//           </li>
//           <hr className="mt-2"/>
//           </div>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default ChronicConditions;

import dayjs from "dayjs";
import React, { useEffect } from "react";
import { FaNotesMedical } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { fetchRpmAgeWiseChronics } from "../../../../Redux/actions/rpmActions";

function ChronicConditions() {
  const { rpmAgeWiseChronicList } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    const payload = {
      fromDate: dayjs().startOf("month").format("MM/DD/YYYY"),
      toDate: dayjs().endOf("month").format("MM/DD/YYYY"),
      status: 1,
    };

    // payload.account_Id = loggedUser.user.account_Id;
    payload.clinic_Id = loggedUser.user.clinic_Id;

    dispatch(fetchRpmAgeWiseChronics(payload));
  }, [dispatch]);

  const ageGroups = rpmAgeWiseChronicList?.ageGroupStatus || [];
  const conditionCounts = rpmAgeWiseChronicList?.chronicConditionCounts || [];

  return (
    <div className="bg-white p-4 rounded-lg border shadow-sm xl:w-1/2 lg:w-1/2 w-full">
      <h2 className="font-semibold font-inter text-gray-800 text-base mb-2">
        Chronic Conditions{" "}
        <span className="text-xs text-gray-500">(Age Group Distribution)</span>
      </h2>

      {/* Age Group Percentage Grid */}
      <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-3 gap-2 text-center text-sm mb-4">
        {ageGroups.map((item, i) => (
          <div
            key={i}
            className="bg-white shadow-xl border rounded-md p-2 text-xs flex flex-col gap-2 items-center justify-center mt-1"
          >
            <span className="text-gray-500">{item.ageGroup}</span>
            <span className="text-gray-800 font-semibold text-base font-inter">
              {item.percentage?.toFixed(2)}%
            </span>
          </div>
        ))}
      </div>

      {/* Chronic Condition Breakdown */}
      <h3 className="text-sm font-inter font-medium text-gray-900 mt-5">
        Chronic Condition Breakdown
      </h3>
      <ul className="space-y-2 text-sm mt-5 h-40 overflow-y-scroll scrollHide">
        {conditionCounts.map((item, i) => (
          <div key={i}>
            <li className="flex items-center justify-between">
              <span className="text-[#004B73] hover:underline cursor-pointer font-inter text-sm font-medium">
                {item.chronicDescription}
              </span>
              <span className="flex items-center gap-1 text-gray-800 font-medium">
                <FaNotesMedical className="text-gray-500" />{" "}
                {item.conditionCount}
              </span>
            </li>
            <hr className="mt-2" />
          </div>
        ))}
      </ul>
    </div>
  );
}

export default ChronicConditions;
